const getRandomInt = function(max: number): number {
  return Math.floor(Math.random() * Math.floor(max))
}

export {
  getRandomInt,
}
